<div role="group" mytime class="example-tel-input-container time-select-wrapper" [formGroup]="parts" (focusin)="onFocusIn($event)"
    (focusout)="onFocusOut($event)">
    <mat-select formControlName="hours" [panelClass]="'panel-left'" (valueChange)="value = {hours:$event,minutes:minutes.value};_handleInput();_doBlur()"
        #hours>
        <mat-option *ngFor="let i of hoursNum" [value]="i">
            {{ i | number:'2.0' }}
        </mat-option>
    </mat-select>

    <div style="padding-right: 8px;">:</div>

    <mat-select #minutes formControlName="minutes" [panelClass]="'panel-right'"
        (valueChange)="value = {hours:hours.value,minutes:$event};_handleInput();_doBlur() ">
        <mat-option *ngFor="let i of mins" [value]="i">
            {{ i | number:'2.0' }}
        </mat-option>
    </mat-select>
</div>